import { FuseDialog, FuseMessage, FuseScrollbars } from '@fuse';
import Loading from '@fuse/components/FuseLoadable/Loading';
import { withStyles } from '@material-ui/core';
import AppContext from 'app/AppContext';
import BannerTop from 'app/Core/Components/BannerTop/BannerTop';
import CheckConvites from 'app/Core/Components/CheckConvites/CheckConvites';
import PainelFixoDireita from 'app/Core/Components/PainelFixoDireita/PainelFixoDireita';
import PrimeirosPassos from 'app/Core/Funcionalidade/PrimeirosPassos/PrimeirosPassos';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import FooterLayout2 from './components/FooterLayout2';
import LeftSideLayout2 from './components/LeftSideLayout2';
import NavbarWrapperLayout2 from './components/NavbarWrapperLayout2';
import RightSideLayout2 from './components/RightSideLayout2';
import ToolbarLayout2 from './components/ToolbarLayout2';

const styles = theme => ({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        '&.boxed': {
            maxWidth: 1280,
            margin: '0 auto',
            boxShadow: theme.shadows[3]
        },
        '&.container': {
            '& .container': {
                maxWidth: 1120,
                width: '100%',
                margin: '0 auto'
            },
            '& .navigation': {}
        }
    },
    content: {
        display: 'flex',
        overflow: 'auto',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%',
        '-webkit-overflow-scrolling': 'touch',
        zIndex: 4
    },
    toolbarWrapper: {
        display: 'flex',
        position: 'relative',
        zIndex: 5
    },
    toolbar: {
        display: 'flex',
        flex: '1 0 auto'
    },
    footerWrapper: {
        position: 'relative',
        zIndex: 5
    },
    footer: {
        display: 'flex',
        flex: '1 0 auto'
    },
    contentPreload: {
        position: 'relative',
        display: 'none',
        overflow: 'auto',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%',
        '-webkit-overflow-scrolling': 'touch',
        zIndex: 2
    }
});

const Layout2 = ({ classes, settings, children, xappRouteParams }) => {

    const layoutConfig = settings.layout.config;

    return (
        <AppContext.Consumer>
            {({ routes }) => (
                <div id="fuse-layout" className={classNames(classes.root, layoutConfig.mode)}>

                    {layoutConfig.leftSidePanel.display && (
                        <LeftSideLayout2 />
                    )}

                    <div className="flex flex-1 flex-col overflow-hidden relative">

                        <BannerTop />
                        <CheckConvites />
                        {layoutConfig.navbar.display && (
                            <NavbarWrapperLayout2 />
                        )}

                        {layoutConfig.toolbar.display && (
                            <ToolbarLayout2 />
                        )}

                        <FuseScrollbars id="PreloadContainer" className={classes.contentPreload}>
                            <Loading pastDelay={true} />
                        </FuseScrollbars>
                        <FuseScrollbars id="ContentContainer" className={classes.content}>
                            <FuseDialog />
                            <PrimeirosPassos />
                            <div className="flex flex-auto flex-col relative h-full">
                                {renderRoutes(routes)}
                                {children}
                                {layoutConfig.footer.display && layoutConfig.footer.style === 'static' && (
                                    <FooterLayout2
                                        xappRouteParams={xappRouteParams}
                                    />
                                )}
                            </div>
                        </FuseScrollbars>

                        {layoutConfig.footer.display && layoutConfig.footer.style === 'fixed' && (
                            <FooterLayout2
                                xappRouteParams={xappRouteParams}
                            />
                        )}

                        {/*<SettingsPanel/>*/}

                    </div>
                    <PainelFixoDireita />

                    {layoutConfig.rightSidePanel.display && (
                        <RightSideLayout2 />
                    )}

                    <FuseMessage />
                </div>)}
        </AppContext.Consumer>
    );
};

function mapStateToProps({ fuse, auth }) {
    return {
        settings: fuse.settings.current,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(Layout2)));
